var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconOrganization = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8CBAC7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.974 3.333v.517h2.052v12.016H2.82V3.85h2.052v-.518h4.102zm-2.461 8.528H4.05v2.403h2.462V11.86zm3.282 0H7.333v2.403h2.462V11.86zM6.513 8.657H4.05v2.403h2.462V8.657zm3.282 0H7.333v2.403h2.462V8.657zM6.513 5.453H4.05v2.403h2.462V5.453zm3.282 0H7.333v2.403h2.462V5.453zM15.538 5.745v.358h1.642v9.763h-5.95V6.103h1.026v-.358h3.282zm-1.969 6.867H11.6v1.952h1.97v-1.952zm2.626 0h-1.97v1.952h1.97v-1.952zm-2.626-2.604H11.6v1.953h1.97v-1.953zm2.626 0h-1.97v1.953h1.97v-1.953zm-2.626-2.603H11.6v1.952h1.97V7.405zm2.626 0h-1.97v1.952h1.97V7.405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 15.865h16v1H2z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconOrganization);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-organization.4007eb00ab6fd25d0272eb44277824ef.svg";